var keyMirror = require('keymirror');

module.exports = {
    endPoints: {
        LOAD_POS_MENU: 'api/posv3/menu/load_menu',

        //Product Controller
        POS_PRODUCT_SEARCH: 'api/v2/product/product_Searchv2',
        SCAN_PRODUCT: 'api/v2/product/scan_product',
        PRODUCT_HISTORY: 'api/v2/product/product_History',
        TRANSACTION_HISTORY: 'api/v2/product/Transaction_History',
        TRANSACTION_DETAILS: 'api/v2/product/product_History_Detail',
        PRODUCT_DETAILS: 'api/v2/product/Additional_Product_Information',

        GET_PRODUCTS: 'api/product-master/get-product-master',

        PRICE_CHECK: 'api/v2/inventory/price-check',

        TRANSACTION_ACTIONS: 'api/posv3/maintenance/GetTransactionHistory',
        AVAILABLE_DISCOUNTS: 'api/v2/discount/available_discounts',
        APPLIED_DISCOUNTS: 'api/v2/discount/get_discounts_applied',
        APPLY_LOYALTY_POINTS: 'api/v2/cart/Update_Loyalty_To_Transaction',

        AVAILABLE_FEES_DONATIONS: 'api/v2/fee-donation/get-active-fees-donations',
        GET_CALCULATION_METHODS: 'api/v2/fee-donation/get-calculation-methods',
        APPLY_FEE_DONATION: 'api/v2/fee-donation/apply-fee-donation',

        SCAN: 'api/v2/guest/Check_Product_Scan',

        GET_BULK_BY_WEIGHT: 'api/v2/cart/Get_Weight_Price',
        GET_BULK_BY_AMOUNT: 'api/v2/cart/Get_Purchase_Amount',

        CHECKOUT: 'api/v2/guest/checkOut_Guest',

        RECREATIONAL: 'api/v2/cart/New_Rec_Transaction',

        GET_LABEL: 'api/posv3/Label/Get_POS_Label',
        GET_LABEL_DETAILS: 'api/posv3/Label/Get_POS_Label_Details',

        GET_AVAILABLE_LABELS: 'api/posv3/label/Get_POS_AvailableLabel',

        BIOTRACK_CHECKOUT: 'api/posv3/Biotrack/CheckOut',
        BIOTRACK_RESET_TRANSMISSION: 'api/posv3/Biotrack/ResetBiotrackTransaction',
        BIOTRACK_VOID_TRANSACTION: 'api/posv3/Biotrack/BioTSaleVoid',

        BIOTRACK_SCAN_GUEST_OUT: 'api/posv3/Biotrack/MDScanPatientOut',

        GET_HELP_DESK: 'api/posv3/lsplocation/get-lsp-help-desk',

        LOAD_ADJUST_lOYALTY_REASONS: 'api/posv3/maintenance/LoadAdjustLoyaltyReasons',

        VOID_TRANSACTION: 'api/v2/cart/Void_Transaction',
        UN_VOID_TRANSACTION: 'api/v2/cart/Un_Void_Transaction',

        RETURN_ITEM: 'api/v2/cart/return_item',

        LOAD_COMPANY_LOGO: 'api/posv3/maintenance/GetLspLogo',

        LOAD_ITEMS_BY_CATEGORY: 'api/posv3/maintenance/ProductCategory',
        PRINT_LABEL: 'api/v2/print-jobs/print-label',
        PRINT_RECEIPT: 'api/v2/print-jobs/print-receipt',
        EMAIL_RECEIPT: 'api/v2/cart/email_receipt',
        PRINT_PREVIEW_RECEIPT: 'api/v2/print-jobs/preview-receipt',
        PRINT_PREORDER_RECEIPT: 'api/v2/print-jobs/print-preorder-receipt',
        PRINT_PICKLIST_RECEIPT: 'api/v2/print-jobs/print-picklist',
        PRINT_PREVIEW_LABELS: 'api/v2/print-jobs/preview-pos-label',
        GET_AVAILABLE_RECEIPT_PRINTERS: 'api/posv3/print/list-receipt-printers',
        GET_AVAILABLE_LABEL_PRINTERS: 'api/posv3/print/list-label-printers',

        /* DELIVERY */
        GET_DIRECTIONS: 'api/maps/get-route',
        GET_DIRECTIONS_BY_ADDR: 'api/maps/get-route-by-address',
        LOAD_DRIVERS: 'api/v2/delivery/get-drivers',
        LOAD_CARS: 'api/posv3/maintenance/GetCars',
        UPDATE_MANIFEST: 'api/v2/manifest/UpdateManifest',
        GET_MANIFEST: 'api/v2/manifest/GetManifest',
        LOAD_RETURN_REASONS: 'api/posv3/maintenance/LoadReturnReasons',
        GET_DELIVERY_CARS: 'api/v2/delivery/get-cars',
        GET_DELIVERY_DRIVERS: 'api/v2/delivery/get-drivers',
        UPDATE_DELIVERY_CAR: 'api/v2/delivery/update-car',
        UPDATE_DELIVERY_DRIVER: 'api/v2/delivery/update-driver',

        UPDATE_TRANSACTION_DATE: 'api/v2/cart/UpdateTransactionDate',
        UPDATE_TRANSACTION_REF: 'api/v2/cart/set-transaction-reference',

        GET_PRODUCT_DETAILS: 'api/posv3/maintenance/ProductSearchOnline',
        GET_LABEL_PRINTER_FOR_TERMINAL: 'api/posv3/print/get-label-printer-for-terminal',

        GET_PRICING_TIER: 'api/posv3/pricing/GetPricingTiers',

        ERROR: '/api/test/broken',
        ERROR_BIOTRACK: '/api/test/broken-biotrack',
        ERROR_METRC: '/api/test/broken-metrc',
        GET_METRC_SETTINGS: 'api/metrc/get-settings',
        ERROR_HYPUR: '/api/test/broken-hypur',

        SET_MN_APPROVAL_CODE: 'api/MN/set-approval-code',
        //Product controller
        GET_TRANSACTION_PAYMENT: 'api/v2/product/get_transaction_payment',
        SET_TRANSACTION_PAYMENT: 'api/v2/product/set_transaction_payment',
        MAKE_ADJUSTMENT: 'api/v2/product/adjust_transaction',
        GET_SIGNUPS: 'api/v2/guest/CheckForSignups',
        NOTIFY_ORDER_READY: 'api/v2/guest/NotifyOrderReady',
        READY_FOR_DELIVERY: 'api/v2/cart/ready-for-delivery',
        BYPASS_STATE_SYSTEM: 'api/v2/cart/bypass-state-system',
        REGISTER_CUSTOMER_FOR_LOYALTY: 'api/v2/guest/register-for-loyalty',
        SEND_REMOTEPAY_LINK_EMAIL: 'api/remotepay/send-email',
        SEND_REMOTEPAY_LINK_TEXT: 'api/remotepay/send-text',
        SET_CART_TOTALS: 'api/remotepay/set-cart-totals',
    },

    actions: keyMirror({
        SEARCH_RESULTS: null,
        PRODUCTS_LOADED: null,
        PRODUCT_HISTORY_LOADED: null,
        TRANSACTION_HISTORY_LOADED: null,
        PRODUCT_DETAILS_LOADED: null,
        AVAIL_DISCOUNTS_LOADED: null,
        APPLIED_DISCOUNTS_LOADED: null,
        AVAIL_FEESDONATIONS_LOADED: null,
        LABELS_LOADED: null,
        AUTO_PRINT_LABELS: null,
        AUTO_PRINT_RECEIPTS: null,
        SET_DEFAULT_LABEL: null,
        POP_UP_NOTES: null,
        SET_INITIAL_LOAD: null,
        SET_RECEIPT_PRINTER: null,
        SET_LABEL_PRINTER: null,
        PRODUCT_SEARCH: null,
        CALCULATION_METHODS_LOADED: null,

        SET_SIDEBAR_PAGE: null,
        TOGGLE_SIDEBAR: null,
        AVAILABLE_PRINTERS_LOADED: null,
        GUEST_LIST_SORTING: null,
        ALL_LABELS_PRINTED: null,
        TRANSACTION_REFERENCE_UPDATED: null,

        OVERRIDE_DHP: null,
        BUILD_NUMBER: null,
        REGION: null,

        SSO_LOGIN_ENABLED: null,
        CURRENT_SERVER: null
    }),

    events: keyMirror({
        CHANGE_EVENT: 'changeEvent',
        SEARCH_EVENT: 'changeEvent',
        BUILD_NUMBER: null,
        REGION_EVENT: null,
        REGION: null,
    }),
    States: [
        { title: '-', option: '' },
        {
            title: 'Alabama',
            option: 'AL',
        },
        {
            title: 'Alaska',
            option: 'AK',
        },
        {
            title: 'American Samoa',
            option: 'AS',
        },
        {
            title: 'Arizona',
            option: 'AZ',
        },
        {
            title: 'Arkansas',
            option: 'AR',
        },
        {
            title: 'California',
            option: 'CA',
        },
        {
            title: 'Colorado',
            option: 'CO',
        },
        {
            title: 'Connecticut',
            option: 'CT',
        },
        {
            title: 'Delaware',
            option: 'DE',
        },
        {
            title: 'District Of Columbia',
            option: 'DC',
        },
        {
            title: 'Federated States Of Micronesia',
            option: 'FM',
        },
        {
            title: 'Florida',
            option: 'FL',
        },
        {
            title: 'Georgia',
            option: 'GA',
        },
        {
            title: 'Guam',
            option: 'GU',
        },
        {
            title: 'Hawaii',
            option: 'HI',
        },
        {
            title: 'Idaho',
            option: 'ID',
        },
        {
            title: 'Illinois',
            option: 'IL',
        },
        {
            title: 'Indiana',
            option: 'IN',
        },
        {
            title: 'Iowa',
            option: 'IA',
        },
        {
            title: 'Kansas',
            option: 'KS',
        },
        {
            title: 'Kentucky',
            option: 'KY',
        },
        {
            title: 'Louisiana',
            option: 'LA',
        },
        {
            title: 'Maine',
            option: 'ME',
        },
        {
            title: 'Marshall Islands',
            option: 'MH',
        },
        {
            title: 'Maryland',
            option: 'MD',
        },
        {
            title: 'Massachusetts',
            option: 'MA',
        },
        {
            title: 'Michigan',
            option: 'MI',
        },
        {
            title: 'Minnesota',
            option: 'MN',
        },
        {
            title: 'Mississippi',
            option: 'MS',
        },
        {
            title: 'Missouri',
            option: 'MO',
        },
        {
            title: 'Montana',
            option: 'MT',
        },
        {
            title: 'Nebraska',
            option: 'NE',
        },
        {
            title: 'Nevada',
            option: 'NV',
        },
        {
            title: 'New Hampshire',
            option: 'NH',
        },
        {
            title: 'New Jersey',
            option: 'NJ',
        },
        {
            title: 'New Mexico',
            option: 'NM',
        },
        {
            title: 'New York',
            option: 'NY',
        },
        {
            title: 'North Carolina',
            option: 'NC',
        },
        {
            title: 'North Dakota',
            option: 'ND',
        },
        {
            title: 'Northern Mariana Islands',
            option: 'MP',
        },
        {
            title: 'Ohio',
            option: 'OH',
        },
        {
            title: 'Oklahoma',
            option: 'OK',
        },
        {
            title: 'Oregon',
            option: 'OR',
        },
        {
            title: 'Palau',
            option: 'PW',
        },
        {
            title: 'Pennsylvania',
            option: 'PA',
        },
        {
            title: 'Puerto Rico',
            option: 'PR',
        },
        {
            title: 'Rhode Island',
            option: 'RI',
        },
        {
            title: 'South Carolina',
            option: 'SC',
        },
        {
            title: 'South Dakota',
            option: 'SD',
        },
        {
            title: 'Tennessee',
            option: 'TN',
        },
        {
            title: 'Texas',
            option: 'TX',
        },
        {
            title: 'Utah',
            option: 'UT',
        },
        {
            title: 'Vermont',
            option: 'VT',
        },
        {
            title: 'Virgin Islands',
            option: 'VI',
        },
        {
            title: 'Virginia',
            option: 'VA',
        },
        {
            title: 'Washington',
            option: 'WA',
        },
        {
            title: 'West Virginia',
            option: 'WV',
        },
        {
            title: 'Wisconsin',
            option: 'WI',
        },
        {
            title: 'Wyoming',
            option: 'WY',
        },
    ],
};



// WEBPACK FOOTER //
// ./ui_src/app/constants/PosConstants.jsx